import { useParams } from 'react-router-dom'
import { useContextLoader } from 'admin/lib/Records'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import { RecordEdit } from './RecordEdit'

export function RecordEditWrapper() {
  const { accountId, projectId, moduleName } = useParams()
  const contextLoader = useContextLoader(accountId, projectId, moduleName)

  if (contextLoader.loaded) {
    return <RecordEdit contextLoader={contextLoader}></RecordEdit>
  }

  return (
    <div
      style={{
        width: '90vw',
        height: '400px',
        margin: '5rem auto 0',
        textAlign: 'center'
      }}
    >
      <ScreenSpin />
    </div>
  )
}
